import React, { useEffect, useState } from 'react';
import { navigate, Redirect, useLocation } from '@reach/router';
import Cookies from 'universal-cookie/es6';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import {
  autoSignIn,
  selectAuthMessage,
  selectSignedIn,
  showApp,
  signOut,
} from 'reducers/auth';
import { AppPath, NO_ACCESS_MESSAGE, NOT_FOUND_PAGE } from 'appConstants';
import ErrorMessage from 'components/errorMessage/ErrorMessage';
import Private from 'components/private/Private';
import { hasPageAccess } from 'helpers/hasPageAccess';
import Footer from './Footer';
import Header from './Header';
import { DashboardApi } from '../../pages/dashboard/dashboardApi';
import { Spinner } from 'components/spinner/Spinner';

type PageProps = {
  isPublic?: boolean;
  isNotFound?: boolean;
  className?: string;
  redirectPath?: string;
  redirectParams?: boolean;
  autoLogin?: boolean;
  children?: any;
};

const cookies = new Cookies();

const Page: React.FC<PageProps> = ({
  isPublic = false,
  isNotFound = false,
  className,
  redirectPath,
  children,
  redirectParams = true,
  autoLogin = true,
}) => {
  const [token, setToken] = useState<string>('');
  const [showPleaseWait, setShowPleaseWait] = useState<boolean>(false);
  const dispatch = useDispatch();
  const isSignedIn = useSelector(selectSignedIn);
  const location = useLocation();
  const pathName = location.pathname;

  const message = useSelector(selectAuthMessage);

  const getFetchAutoLoginToken = async () => {
    const result = await DashboardApi.getAutoLoginToken();
    if (result.data) {
      setToken(result.data.token);
    }
    if (result.error) {
      setToken('');
    }
  };

  const queryParams: any = location
    ? queryString.parse(location.search)
    : undefined;

  useEffect(() => {
    if(isSignedIn){
      getFetchAutoLoginToken();
    }
  }, []);    

  useEffect(() => {
    if (isSignedIn && token && queryParams.redirectURL) {
      setShowPleaseWait(true);
      const holdsHttps = queryParams.redirectURL.indexOf("https://") !== -1;
      const newRedirectURL = (holdsHttps ? "" : "https://") + queryParams.redirectURL.replace("AUTOLOGINTOKEN", token) + "&area=" + queryParams.area;
      window.location.href = newRedirectURL;
    }
  }, [token]);

  useEffect(() => {
    if (queryParams?.auth === 'sign-out' && isSignedIn) dispatch(signOut());
  }, []);


  if (queryParams?.auth === 'sign-out' && isSignedIn) return null;

  // const getURLToken = new URLSearchParams(window.location.search).get('token');
  // if (getURLToken && autoLogin) {
  //   dispatch(autoSignIn({ token: encodeURIComponent(getURLToken) }));

  //   if (message) {
  //     navigate(AppPath.SIGN_IN);
  //   }
  //   return (
  //     <div className="PageSpinner">
  //       <Spinner />
  //     </div>
  //   );
  // }

  if (isSignedIn && isPublic) {
    return (
      <Redirect
        noThrow
        to={
          redirectPath
            ? `/${redirectPath}${redirectParams ? '?area=&token=' : ''}`
            : AppPath.DASHBOARD
        }
      />
    );
  }

  return isPublic ? (
    <div className={`Page ${className ? className : ''}`}>
      <Header />
      <main className="Main">{children}</main>
      <Footer />
    </div>
  ) : (
    <Private>
      <div className={`Page ${className ? className : ''}`}>
        <Header />
        <main className="Main">
          {hasPageAccess(pathName) ? (
            children
          ) : (
            <>
              {showPleaseWait ? 
                <div className="PleaseWaitMsg">
                  <div className="MsgContainer">
                    <Spinner />
                    <div className="Txt">Please wait</div>
                  </div>
                </div>
                :
                <ErrorMessage
                  message={isNotFound ? NOT_FOUND_PAGE : NO_ACCESS_MESSAGE}
                />
              }
            </>
          )}
        </main>
        <Footer />
      </div>
    </Private>
  );
};

export default Page;
